import { render, staticRenderFns } from "./boxsvg3.vue?vue&type=template&id=6c0186fe&scoped=true&"
var script = {}
import style0 from "./boxsvg3.vue?vue&type=style&index=0&id=6c0186fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0186fe",
  null
  
)

export default component.exports